
import crtBg from '@/assets/images/zs_bg.jpg'
export default class certificatePx {
  constructor(parmsData, callback) {
    // console.log('dataarguments',parmsData)
    // name:'李蔚国',
    //   companyName:'逸飞教育',
    //   IDNo:'62230119900901331x',
    //   pxDate:'2022-03-04',
    //   bottomDate:'2022-03-04'
    this.parmsData = parmsData
    if (this.parmsData.pxDate && this.parmsData.pxDate.indexOf('-') !== -1) {
      this.parmsData.pxDate = this.parmsData.pxDate.split('-')
    }
    if (this.parmsData.bottomDate && this.parmsData.bottomDate.indexOf('-') !== -1) {
      this.parmsData.bottomDate = this.parmsData.bottomDate.split('-')
    }
    this.callback = callback
    this.imgWidth = 798
    this.imgHeight = 530
    this.content = ''
    this.initMethod()
  }

  initMethod() {
    const img = new Image()
    const that = this
    img.src = crtBg
    img.onload = function() {
      that.createCanvas(img)
    }
  }

  createCanvas(imageItem) {
    var canvas = document.createElement('canvas') // 创建canvas元素
    canvas.width = this.imgWidth // canvas宽度
    canvas.height = this.imgHeight // canvas的高度
    var context = canvas.getContext('2d') // 创建渲染
    context.fillStyle = '#fff'
    context.fillRect(0, 0, this.imgWidth, this.imgHeight)
    context.drawImage(imageItem, 0, 0, this.imgWidth, this.imgHeight)

    context.textAlign = 'center'
    const txt = `在${this.parmsData.publish_organ}举办的${this.parmsData.category_name}岗位人员安全技能提升培训，经考试合格，特此证明。`

    this.setText(399, 100, `${this.parmsData.category_name}人员培训合格证`, context, 'bold 30px arial')

    context.textAlign = 'left'
    this.setText(90, 210, '学员', context, 'bold 20px arial')
    this.setLine(140, 217, 250, 217, context)
    
    this.setText(260, 210, '工作单位', context, 'bold 20px arial')
    this.setLine(350, 217, 730, 217, context)

    this.setText(75, 252, '身份证号', context, 'bold 20px arial')
    this.setLine(163, 259, 409, 259, context)

    this.setText(406, 252, '，参加', context, 'bold 20px arial')
    this.setLine(470, 259, 530, 259, context)

    this.setText(530, 252, '年', context, 'bold 20px arial')
    this.setLine(553, 259, 618, 259, context)
    this.setText(620, 252, '月', context, 'bold 20px arial')
    this.setLine(644, 259, 708, 259, context)
    this.setText(710, 252, '日', context, 'bold 20px arial')

    this.setText(600, 420, '年', context, 'bold 16px arial')
    this.setText(650, 420, '月', context, 'bold 16px arial')
    this.setText(700, 420, '日', context, 'bold 16px arial')

    this.setText(75, 294, txt.slice(0, 32), context, 'bold 20px arial')

    this.setText(75, 333, txt.slice(32), context, 'bold 20px arial')

    // 开始绘制文本
    // 姓名
    this.setText(157, 210, this.parmsData.name, context)
    // 公司
    this.setText(365, 210, this.parmsData.companyName, context)
    // 身份证号
    this.setText(170, 252, this.parmsData.IDNo, context)
    // 参加时间
    if (this.parmsData.pxDate.length > 2) {
      this.setText(486, 252, this.parmsData.pxDate[0], context)
      this.setText(570, 252, this.parmsData.pxDate[1], context)
      this.setText(670, 252, this.parmsData.pxDate[2], context)
    }
    if (this.parmsData.bottomDate.length > 2) {
      this.setText(560, 420, this.parmsData.bottomDate[0], context)
      this.setText(630, 420, this.parmsData.bottomDate[1], context)
      this.setText(680, 420, this.parmsData.bottomDate[2], context)
    }
    var fullQuality = canvas.toDataURL('image/jpeg', 1.0)
    this.callback(fullQuality, this.index)
  }

  setText(x, y, text, cans, fontSize = 'bold 16px arial') {
    cans.font = fontSize
    cans.fillStyle = '#000000'
    cans.fillText(text, x, y)
  }

  setLine(x1, y1, x2, y2, context) {
    context.moveTo(x1,y1)
    context.lineTo(x2,y2)
    context.stroke()
  }

  // 获取字符串的真实长度（字节长度）
  getTrueLength(str) {
    var len = str.length; var truelen = 0
    for (var x = 0; x < len; x++) {
      if (str.charCodeAt(x) > 128) {
        truelen += 2
      } else {
        truelen += 1
      }
    }
    return truelen
  }
}
